import { render } from "./ExamModal.vue?vue&type=template&id=10f16d0e"
import script from "./ExamModal.vue?vue&type=script&lang=js"
export * from "./ExamModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__